export const KEY_ICONS = {
	CLEAR: "e5c9",
	ENTER: "e86c",
	SHUFFLE: "e933",
	CLUE: "f8ea",
};

export const ICONS = {
	CLOSE: "e5cd",
	INFO: "e88e",
	SETTINGS: "e8b8",
	SHARE: "e80d",
	STAR: "e838",
	STAR_OUTLINE: "e83a",
};
